const normalizeErrorCode = (value) => {
  if (value == null) return null;
  const normalized = String(value).trim();
  return normalized || null;
};

export const extractApiErrorCode = (error = null) =>
  normalizeErrorCode(error?.code ?? error?.payload?.error?.code ?? error?.payload?.code ?? null);

export const shouldBlockJoinBundleRecovery = (error = null) => {
  const status = Number(error?.status ?? error?.response?.status ?? error?.payload?.status ?? null);
  if (status === 503) return true;

  const code = extractApiErrorCode(error);
  if (code === 'welcome_unavailable' || code === 'welcome_ref_mismatch') {
    return true;
  }

  const message = String(
    error?.message ?? error?.payload?.error?.message ?? error?.payload?.message ?? '',
  ).toLowerCase();
  return (
    message.includes('no welcome was created') ||
    message.includes('welcome does not match the provided key package reference') ||
    message.includes('retry after ensuring the group is reset on staging')
  );
};
